import { PendingPartnerInvite } from 'apis/UsersApi';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';

const ACCEPTED = 2;
const DECLINED = 3;

type InviteCardProps = {
    disabled: boolean;
    invite: PendingPartnerInvite;
    onRespond: (invite: PendingPartnerInvite, statusId: number) => void;
};

export const InviteCard = (props: InviteCardProps) => {

    const { disabled, invite, onRespond } = props;

    return (
        <div className="d-flex align-items-center gap-3 p-3 rounded border bg-light">

            {/* Info */}
            <div className="d-flex flex-column flex-grow-1 overflow-hidden">
                <span className="fw-semibold text-truncate">
                    {invite.partnerName}
                </span>
                <small className="text-muted">
                    <FormattedMessage defaultMessage="Invited by" id="invited_by.990fc877" />
                    {' '}
                    <span className="fw-medium">
                        {invite.invitedByName}
                    </span>
                    <span className="mx-1">
                        &middot;
                    </span>
                    {invite.invitationDate}
                </small>
            </div>

            {/* Actions */}
            <div className="d-flex gap-2 flex-shrink-0">
                <Button
                    disabled={disabled}
                    onClick={() => onRespond(invite, ACCEPTED)}
                    size="sm"
                >
                    <i className="fa-solid fa-check me-1" />
                    {<FormattedMessage defaultMessage="Accept" id="accept.555507af" />}
                </Button>
                <Button
                    disabled={disabled}
                    onClick={() => onRespond(invite, DECLINED)}
                    size="sm"
                    variant="outline-danger"
                >
                    <i className="fa-solid fa-xmark me-1" />
                    <FormattedMessage defaultMessage="Decline" id="decline.8b06bd8b" />
                </Button>
            </div>

        </div>
    );

};